import { render, staticRenderFns } from "./TriggerCampaignForm.vue?vue&type=template&id=db5c5d1e&scoped=true"
import script from "./TriggerCampaignForm.vue?vue&type=script&lang=js"
export * from "./TriggerCampaignForm.vue?vue&type=script&lang=js"
import style0 from "./TriggerCampaignForm.vue?vue&type=style&index=0&id=db5c5d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5c5d1e",
  null
  
)

export default component.exports